import { renderError, Fetch, displayError } from './helpers';

export const cargoSpaceCalculator = () => {

  const isCargoSpaceCalculator = document.querySelector('.cargo-space-calculator')
  if (!isCargoSpaceCalculator) return;

  const calculatorForm = document.querySelector('.cargo-space-calculator .calculator__form');
  const resultContainer = document.querySelector('.cargo-space-calculator .calculator__form-result-desc');
  const imageContainer = document.querySelector('.cargo-space-calculator .calculator__form-result-img');
  const ctaContainer = document.querySelector('.cargo-space-calculator .calculator__cta');

  if (!calculatorForm) {
    console.error('Форма калькулятора не найдена');
    return;
  }

  // Получаем все числовые инпуты калькулятора
  const calculatorInputs = calculatorForm.querySelectorAll('input[name="length"], input[name="width"], input[name="height"], input[name="mass"]');

  // Добавляем валидацию ко всем числовым инпутам
  calculatorInputs.forEach(input => {
    input.addEventListener('input', function (event) {
      // Разрешаем только цифры, точку и запятую
      event.target.value = event.target.value.replace(/[^0-9.,]/g, '');
    });
  });

  // Функция для нормализации числового ввода (заменяет запятую на точку)
  function normalizeDecimalInput(value) {
    if (typeof value === 'string') {
      return value.replace(',', '.');
    }
    return value;
  }

  calculatorForm.addEventListener('submit', async function (event) {
    event.preventDefault();

    try {
      // Собираем данные из формы
      const formData = new FormData(calculatorForm);

      // Преобразуем данные в нужный формат с нормализацией десятичных значений
      const requestData = {
        cargo_space: formData.get('cargo_space'),
        cargo: {
          length: parseFloat(normalizeDecimalInput(formData.get('length'))),
          width: parseFloat(normalizeDecimalInput(formData.get('width'))),
          height: parseFloat(normalizeDecimalInput(formData.get('height'))),
          mass: parseFloat(normalizeDecimalInput(formData.get('mass')))
        }
      };

      // Валидация данных
      if (!requestData.cargo_space) {
        return 'Выберите тип контейнера';
      }

      if (!requestData.cargo.length || !requestData.cargo.width ||
        !requestData.cargo.height || !requestData.cargo.mass) {
        return 'Заполните все поля размеров и веса упаковки';
      }

      if (requestData.cargo.length <= 0 || requestData.cargo.width <= 0 ||
        requestData.cargo.height <= 0 || requestData.cargo.mass <= 0) {
        return 'Все значения должны быть больше нуля';
      }

      // Получаем эндпоинт из формы
      const endpoint = calculatorForm.getAttribute('data-end-point');
      const currentDomain = window.location.origin;
      const fullUrl = currentDomain + endpoint;

      // Отправляем запрос на сервер
      const response = await Fetch(fullUrl, {
        method: 'POST',
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        throw new Error(`Ошибка сервера: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();

      // Отображаем результат
      displayCargoSpaceResult(result);

    } catch (error) {
      console.error('Ошибка при расчете:', error);
      displayError(error.message, resultContainer);
    }
  });

  function displayCargoSpaceResult(data) {
    if (!resultContainer) {
      console.error('Контейнер результатов не найден');
      return;
    }

    const quantity = data.packing_count || 0;
    const totalWeight = data.calculation_mass || 0;

    imageContainer.classList.add('calculator__form-result-img--hide');
    ctaContainer.classList.add('calculator__cta--visible');

    resultContainer.innerHTML = `
      <div class="calculator__form-result-desc-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="76" height="50" viewBox="0 0 76 50" fill="none">
            <path d="M0 6C0 2.68629 2.68629 0 6 0H70C73.3137 0 76 2.68629 76 6V44C76 47.3137 73.3137 50 70 50H6C2.68629 50 0 47.3137 0 44V6Z" fill="white"/>
            <path d="M24 18.2727C24 16.7263 25.2536 15.4727 26.8 15.4727H49.2C50.7464 15.4727 52 16.7263 52 18.2727C52 19.8191 50.7464 21.0727 49.2 21.0727H26.8C25.2536 21.0727 24 19.8191 24 18.2727Z" fill="#0065CE"/>
            <path d="M43.7273 10C45.2737 10 46.5273 11.2536 46.5273 12.8V35.2C46.5273 36.7464 45.2737 38 43.7273 38C42.1809 38 40.9273 36.7464 40.9273 35.2L40.9273 12.8C40.9273 11.2536 42.1809 10 43.7273 10Z" fill="#0065CE"/>
            <path d="M24 29.7273C24 28.1809 25.2536 26.9273 26.8 26.9273H49.2C50.7464 26.9273 52 28.1809 52 29.7273C52 31.2737 50.7464 32.5273 49.2 32.5273H26.8C25.2536 32.5273 24 31.2737 24 29.7273Z" fill="#0065CE"/>
            <path d="M32.2727 10C33.8191 10 35.0727 11.2536 35.0727 12.8V35.2C35.0727 36.7464 33.8191 38 32.2727 38C30.7263 38 29.4727 36.7464 29.4727 35.2L29.4727 12.8C29.4727 11.2536 30.7263 10 32.2727 10Z" fill="#0065CE"/>
          </svg>
          <div class="calculator__form-result-txt-container">
              <p class="calculator__form-result-txt">Количество упаковок, которое помещается в выбранный контейнер:</p>
              <p class="calculator__form-result-txt-accent cargo-space-quantity">${quantity} шт</p>
          </div>
      </div>`;

    if (totalWeight > 0) {
      resultContainer.innerHTML += `
        <div class="calculator__form-result-desc-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="76" height="50" viewBox="0 0 76 50" fill="none">
              <path d="M0 6C0 2.68629 2.68629 0 6 0H70C73.3137 0 76 2.68629 76 6V44C76 47.3137 73.3137 50 70 50H6C2.68629 50 0 47.3137 0 44V6Z" fill="white"/>
              <path d="M56.3994 12C56.9517 12 57.3994 12.4477 57.3994 13V35C57.3994 35.5523 56.9517 36 56.3994 36H20C19.4477 36 19 35.5523 19 35L19 13C19 12.4477 19.4477 12 20 12L56.3994 12ZM26.6797 17.1436C25.6193 17.1436 24.7598 18.0041 24.7598 19.0645V28.9385C24.7599 29.9988 25.6194 30.8584 26.6797 30.8584C27.7398 30.8582 28.5995 29.9987 28.5996 28.9385V19.0645C28.5996 18.0042 27.7399 17.1438 26.6797 17.1436ZM34.3604 17.1436C33.3001 17.1437 32.4404 18.0042 32.4404 19.0645V28.9385C32.4405 29.9987 33.3002 30.8582 34.3604 30.8584C35.4207 30.8584 36.2802 29.9988 36.2803 28.9385V19.0645C36.2803 18.0041 35.4207 17.1436 34.3604 17.1436ZM42.0381 17.1436C40.9777 17.1436 40.1182 18.0041 40.1182 19.0645V28.9385C40.1183 29.9988 40.9778 30.8584 42.0381 30.8584C43.0984 30.8583 43.9579 29.9988 43.958 28.9385V19.0645C43.958 18.0041 43.0984 17.1436 42.0381 17.1436ZM49.7197 17.1436C48.6593 17.1436 47.7998 18.0041 47.7998 19.0645V28.9385C47.7999 29.9988 48.6594 30.8584 49.7197 30.8584C50.7799 30.8582 51.6396 29.9987 51.6396 28.9385V19.0645C51.6396 18.0042 50.78 17.1437 49.7197 17.1436Z" fill="#0065CE"/>
            </svg>
            <div class="calculator__form-result-txt-container">
                <p class="calculator__form-result-txt">Суммарный вес упаковок, которое помещается в контейнер:</p>
                <p class="calculator__form-result-txt-accent cargo-space-weight">${totalWeight.toLocaleString('ru-RU')} кг</p>
            </div>
        </div>`;
    }
  }
};

export const ldmCalculator = () => {
  const isLdmCalculator = document.querySelector('.calculator.ldm');
  if (!isLdmCalculator) return;

  const calculatorForm = document.querySelector('.calculator.ldm .calculator__form');
  const resultContainer = document.querySelector('.calculator.ldm .calculator__form-result-desc');
  const imageContainer = document.querySelector('.calculator.ldm .calculator__form-result-img');
  const ctaContainer = document.querySelector('.calculator.ldm .calculator__cta');

  if (!calculatorForm) {
    console.error('Форма LDM калькулятора не найдена');
    return;
  }

  // Получаем все числовые инпуты калькулятора
  const calculatorInputs = calculatorForm.querySelectorAll('input[name="length"], input[name="width"], input[name="height"], input[name="palet_count"]');

  // Добавляем валидацию ко всем числовым инпутам
  calculatorInputs.forEach(input => {
    input.addEventListener('input', function (event) {
      // Разрешаем только цифры, точку и запятую
      event.target.value = event.target.value.replace(/[^0-9.,]/g, '');
    });
  });

  // Функция для нормализации числового ввода (заменяет запятую на точку)
  function normalizeDecimalInput(value) {
    if (typeof value === 'string') {
      return value.replace(',', '.');
    }
    return value;
  }

  calculatorForm.addEventListener('submit', async function (event) {
    event.preventDefault();

    try {
      // Собираем данные из формы
      const formData = new FormData(calculatorForm);

      // Преобразуем данные в нужный формат с нормализацией десятичных значений
      const requestData = {
        length: parseFloat(normalizeDecimalInput(formData.get('length'))),
        width: parseFloat(normalizeDecimalInput(formData.get('width'))),
        height: parseFloat(normalizeDecimalInput(formData.get('height'))),
        palet_count: parseFloat(normalizeDecimalInput(formData.get('palet_count')))
      };

      // Валидация данных
      if (!requestData.length || !requestData.width || !requestData.height || !requestData.palet_count) {
        displayError('Заполните все поля', resultContainer);
        return;
      }

      if (requestData.length <= 0 || requestData.width <= 0 || requestData.height <= 0 || requestData.palet_count <= 0) {
        displayError('Все значения должны быть больше нуля', resultContainer);
        return;
      }

      // Получаем эндпоинт из формы
      const endpoint = calculatorForm.getAttribute('data-end-point');
      const currentDomain = window.location.origin;
      const fullUrl = currentDomain + endpoint;

      // Отправляем запрос на сервер
      const response = await Fetch(fullUrl, {
        method: 'POST',
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        throw new Error(`Ошибка сервера: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();

      // Отображаем результат
      displayLdmResult(result);

    } catch (error) {
      console.error('Ошибка при расчете LDM:', error);
      displayError(error.message, resultContainer);
    }
  });

  function displayLdmResult(data) {
    if (!resultContainer) {
      console.error('Контейнер результатов не найден');
      return;
    }

    const ldm = data.ldm || 0;
    const totalLdm = data.total_ldm || 0;

    imageContainer.classList.add('calculator__form-result-img--hide');
    ctaContainer.classList.add('calculator__cta--visible');

    resultContainer.innerHTML = `
      <div class="calculator__form-result-desc-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="76" height="51" viewBox="0 0 76 51" fill="none">
            <path d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5H70C73.3137 0.5 76 3.18629 76 6.5V44.5C76 47.8137 73.3137 50.5 70 50.5H6C2.68629 50.5 0 47.8137 0 44.5V6.5Z" fill="white"/>
            <path d="M24 33.5149C24 32.6532 24.6964 31.9546 25.5556 31.9546H50.4444C51.3036 31.9546 52 32.6532 52 33.5149V35.1454H24V33.5149Z" fill="#0065CE"/>
            <path d="M24 35.1454H29.25V36.9396C29.25 37.8014 28.5536 38.5 27.6944 38.5H25.5556C24.6964 38.5 24 37.8014 24 36.9396V35.1454Z" fill="#0065CE"/>
            <path d="M35.1604 35.1454H40.8546V36.9396C40.8546 37.8014 40.1581 38.5 39.299 38.5H36.7159C35.8568 38.5 35.1604 37.8014 35.1604 36.9396V35.1454Z" fill="#0065CE"/>
            <path d="M46.75 35.1454H52V36.9396C52 37.8014 51.3036 38.5 50.4444 38.5H48.3056C47.4464 38.5 46.75 37.8014 46.75 36.9396V35.1454Z" fill="#0065CE"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M26.8 10.5C26.0268 10.5 25.4 11.0738 25.4 11.7815V27.4184C25.4 28.1262 26.0268 28.7 26.8 28.7H49.2C49.9732 28.7 50.6 28.1262 50.6 27.4184V11.7815C50.6 11.0738 49.9732 10.5 49.2 10.5H43.6L43.6 19.1029C43.6 19.8107 42.9732 20.3845 42.2 20.3845H33.8C33.0268 20.3845 32.4 19.8107 32.4 19.1029L32.4 10.5H26.8Z" fill="#0065CE"/>
            <path d="M35.2 10.5H40.8L40.8 16.2788C40.8 16.9866 40.1732 17.5603 39.4 17.5603H36.6C35.8268 17.5603 35.2 16.9866 35.2 16.2788L35.2 10.5Z" fill="#0065CE"/>
          </svg>
          <div class="calculator__form-result-txt-container">
              <p class="calculator__form-result-txt">LDM одного поддона:</p>
              <p class="calculator__form-result-txt-accent ldm-single">${ldm.toFixed(2)} м³</p>
          </div>
      </div>
      <div class="calculator__form-result-desc-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="76" height="51" viewBox="0 0 76 51" fill="none">
            <path d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5H70C73.3137 0.5 76 3.18629 76 6.5V44.5C76 47.8137 73.3137 50.5 70 50.5H6C2.68629 50.5 0 47.8137 0 44.5V6.5Z" fill="white"/>
            <path d="M23 13.1099C23 12.2208 23.7582 11.5 24.6935 11.5H51.7893C52.7246 11.5 53.4828 12.2208 53.4828 13.1099V14.7198H23V13.1099Z" fill="#0065CE"/>
            <path d="M23 14.7198H28.7155V16.6433C28.7155 17.5324 27.9573 18.2532 27.022 18.2532H24.6935C23.7582 18.2532 23 17.5324 23 16.6433V14.7198Z" fill="#0065CE"/>
            <path d="M35.15 14.7198H41.3491V16.6433C41.3491 17.5324 40.5909 18.2532 39.6556 18.2532H36.8434C35.9082 18.2532 35.15 17.5324 35.15 16.6433V14.7198Z" fill="#0065CE"/>
            <path d="M47.7672 14.7198H53.4828V16.6433C53.4828 17.5324 52.7246 18.2532 51.7893 18.2532H49.4607C48.5254 18.2532 47.7672 17.5324 47.7672 16.6433V14.7198Z" fill="#0065CE"/>
            <path d="M23 22.7329C23 21.8438 23.7582 21.123 24.6935 21.123H51.7893C52.7246 21.123 53.4828 21.8438 53.4828 22.7329V24.379H23V22.7329Z" fill="#0065CE"/>
            <path d="M23 24.379H28.7155V26.2663C28.7155 27.1555 27.9573 27.8762 27.022 27.8762H24.6935C23.7582 27.8762 23 27.1555 23 26.2663V24.379Z" fill="#0065CE"/>
            <path d="M35.15 24.379H41.3491V26.2663C41.3491 27.1555 40.5909 27.8762 39.6556 27.8762H36.8434C35.9082 27.8762 35.15 27.1555 35.15 26.2663V24.379Z" fill="#0065CE"/>
            <path d="M47.7672 24.379H53.4828V26.2663C53.4828 27.1555 52.7246 27.8762 51.7893 27.8762H49.4607C48.5254 27.8762 47.7672 27.1555 47.7672 26.2663V24.379Z" fill="#0065CE"/>
            <path d="M23 32.3567C23 31.4676 23.7582 30.7468 24.6935 30.7468H51.7893C52.7246 30.7468 53.4828 31.4676 53.4828 32.3567V34.0389H23V32.3567Z" fill="#0065CE"/>
            <path d="M23 34.0389H28.7155V35.8901C28.7155 36.7792 27.9573 37.5 27.022 37.5H24.6935C23.7582 37.5 23 36.7792 23 35.8901V34.0389Z" fill="#0065CE"/>
            <path d="M35.15 34.0389H41.3491V35.8901C41.3491 36.7792 40.5909 37.5 39.6556 37.5H36.8434C35.9082 37.5 35.15 36.7792 35.15 35.8901V34.0389Z" fill="#0065CE"/>
            <path d="M47.7672 34.0389H53.4828V35.8901C53.4828 36.7792 52.7246 37.5 51.7893 37.5H49.4607C48.5254 37.5 47.7672 36.7792 47.7672 35.8901V34.0389Z" fill="#0065CE"/>
          </svg>
          <div class="calculator__form-result-txt-container">
              <p class="calculator__form-result-txt">Общий LDM всех поддонов:</p>
              <p class="calculator__form-result-txt-accent ldm-total">${totalLdm.toFixed(2)} м³</p>
          </div>
      </div>`;
  }
};

export const boxVolumeCalculator = () => {
  const isBoxVolumeCalculator = document.querySelector('.cargo-volume-and-weight');
  if (!isBoxVolumeCalculator) return;

  const calculatorForm = document.querySelector('.cargo-volume-and-weight .calculator__form');
  const resultContainer = document.querySelector('.cargo-volume-and-weight .calculator__form-result-desc');
  const imageContainer = document.querySelector('.cargo-volume-and-weight .calculator__form-result-img');
  const ctaContainer = document.querySelector('.cargo-volume-and-weight .calculator__cta');

  if (!calculatorForm) {
    console.error('Форма калькулятора объема не найдена');
    return;
  }

  // Получаем все числовые инпуты калькулятора
  const calculatorInputs = calculatorForm.querySelectorAll('input[name="length"], input[name="width"], input[name="height"], input[name="box_count"]');

  // Добавляем валидацию ко всем числовым инпутам
  calculatorInputs.forEach(input => {
    input.addEventListener('input', function (event) {
      // Разрешаем только цифры, точку и запятую
      event.target.value = event.target.value.replace(/[^0-9.,]/g, '');
    });
  });

  // Функция для нормализации числового ввода (заменяет запятую на точку)
  function normalizeDecimalInput(value) {
    if (typeof value === 'string') {
      return value.replace(',', '.');
    }
    return value;
  }

  calculatorForm.addEventListener('submit', async function (event) {
    event.preventDefault();

    try {
      // Собираем данные из формы
      const formData = new FormData(calculatorForm);

      // Преобразуем данные в нужный формат с нормализацией десятичных значений
      const requestData = {
        length: parseFloat(normalizeDecimalInput(formData.get('length'))),
        width: parseFloat(normalizeDecimalInput(formData.get('width'))),
        height: parseFloat(normalizeDecimalInput(formData.get('height'))),
        measure_unit: formData.get('measure_unit'),
        box_count: parseFloat(normalizeDecimalInput(formData.get('box_count')))
      };

      // Валидация данных
      if (!requestData.length || !requestData.width || !requestData.height || !requestData.box_count) {
        displayError('Заполните все поля', resultContainer);
        return;
      }

      if (requestData.length <= 0 || requestData.width <= 0 || requestData.height <= 0 || requestData.box_count <= 0) {
        displayError('Все значения должны быть больше нуля', resultContainer);
        return;
      }

      if (!requestData.measure_unit) {
        displayError('Выберите единицу измерения', resultContainer);
        return;
      }

      // Получаем эндпоинт из формы
      const endpoint = calculatorForm.getAttribute('data-end-point');
      const currentDomain = window.location.origin;
      const fullUrl = currentDomain + endpoint;

      // Отправляем запрос на сервер
      const response = await Fetch(fullUrl, {
        method: 'POST',
        body: JSON.stringify(requestData)
      });

      if (!response.ok) {
        throw new Error(`Ошибка сервера: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();

      // Отображаем результат
      displayBoxVolumeResult(result);

    } catch (error) {
      console.error('Ошибка при расчете объема:', error);
      displayError(error.message, resultContainer);
    }
  });

  function displayBoxVolumeResult(data) {
    if (!resultContainer) {
      console.error('Контейнер результатов не найден');
      return;
    }

    const boxVolume = data.box_volume || 0;
    const totalBoxVolume = data.total_box_volume || 0;

    imageContainer.classList.add('calculator__form-result-img--hide');
    ctaContainer.classList.add('calculator__cta--visible');

    resultContainer.innerHTML = `
      <div class="calculator__form-result-desc-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="76" height="51" viewBox="0 0 76 51" fill="none">
            <path d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5H70C73.3137 0.5 76 3.18629 76 6.5V44.5C76 47.8137 73.3137 50.5 70 50.5H6C2.68629 50.5 0 47.8137 0 44.5V6.5Z" fill="white"/>
            <path d="M38 20.8494L43.3008 18.6641L30.1758 13.2459L25.6503 15.1134C25.4219 15.2072 25.2075 15.3336 25.0133 15.489L38 20.8494ZM24.0613 17.044C24.0204 17.2356 23.9999 17.4312 24 17.6274V31.4365C23.9999 31.978 24.1571 32.5072 24.4512 32.9556C24.7454 33.4041 25.163 33.7513 25.6503 33.9523L35.725 38.1117C36.1812 38.2995 36.6478 38.4284 37.125 38.4982V22.4351L24.0613 17.044ZM38.875 38.5C39.3548 38.4288 39.8248 38.2991 40.275 38.1135L50.3497 33.9542C50.8372 33.7529 51.2551 33.4055 51.5492 32.9567C51.8434 32.5079 52.0004 31.9784 52 31.4365V17.6274C52 17.4275 51.9796 17.2325 51.9388 17.0422L38.875 22.4351V38.5ZM50.9867 15.4908L45.6562 17.6924L32.5313 12.2742L35.725 10.9522C37.1854 10.3493 38.8146 10.3493 40.275 10.9522L50.3497 15.1116C50.5781 15.2054 50.7925 15.3318 50.9867 15.4872" fill="#0065CE"/>
          </svg>
          <div class="calculator__form-result-txt-container">
              <p class="calculator__form-result-txt">Объем коробки:</p>
              <p class="calculator__form-result-txt-accent box-volume-single">${boxVolume.toFixed(2)} м³</p>
          </div>
      </div>
      <div class="calculator__form-result-desc-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="76" height="51" viewBox="0 0 76 51" fill="none">
            <path d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5H70C73.3137 0.5 76 3.18629 76 6.5V44.5C76 47.8137 73.3137 50.5 70 50.5H6C2.68629 50.5 0 47.8137 0 44.5V6.5Z" fill="white"/>
            <path d="M22 21.3494L27.3008 19.1641L14.1758 13.7459L9.65025 15.6134C9.42192 15.7072 9.2075 15.8336 9.01325 15.989L22 21.3494ZM8.06125 17.544C8.02043 17.7356 7.99989 17.9312 8 18.1274V31.9365C7.99991 32.478 8.15709 33.0072 8.45125 33.4556C8.7454 33.9041 9.16304 34.2513 9.65025 34.4523L19.725 38.6117C20.1812 38.7995 20.6478 38.9284 21.125 38.9982V22.9351L8.06125 17.544ZM22.875 39C23.3548 38.9288 23.8248 38.7991 24.275 38.6135L34.3497 34.4542C34.8372 34.2529 35.2551 33.9055 35.5492 33.4567C35.8434 33.0079 36.0004 32.4784 36 31.9365V18.1274C36 17.9275 35.9796 17.7325 35.9388 17.5422L22.875 22.9351V39ZM34.9867 15.9908L29.6562 18.1924L16.5313 12.7742L19.725 11.4522C21.1854 10.8493 22.8146 10.8493 24.275 11.4522L34.3497 15.6116C34.5781 15.7054 34.7925 15.8318 34.9867 15.9872" fill="#0065CE"/>
            <path d="M54 21.3494L59.3008 19.1641L46.1758 13.7459L41.6503 15.6134C41.4219 15.7072 41.2075 15.8336 41.0133 15.989L54 21.3494ZM40.0613 17.544C40.0204 17.7356 39.9999 17.9312 40 18.1274V31.9365C39.9999 32.478 40.1571 33.0072 40.4512 33.4556C40.7454 33.9041 41.163 34.2513 41.6503 34.4523L51.725 38.6117C52.1812 38.7995 52.6478 38.9284 53.125 38.9982V22.9351L40.0613 17.544ZM54.875 39C55.3548 38.9288 55.8248 38.7991 56.275 38.6135L66.3497 34.4542C66.8372 34.2529 67.2551 33.9055 67.5492 33.4567C67.8434 33.0079 68.0004 32.4784 68 31.9365V18.1274C68 17.9275 67.9796 17.7325 67.9388 17.5422L54.875 22.9351V39ZM66.9867 15.9908L61.6562 18.1924L48.5313 12.7742L51.725 11.4522C53.1854 10.8493 54.8146 10.8493 56.275 11.4522L66.3497 15.6116C66.5781 15.7054 66.7925 15.8318 66.9867 15.9872" fill="#0065CE"/>
          </svg>
          <div class="calculator__form-result-txt-container">
              <p class="calculator__form-result-txt">Общий объем коробок:</p>
              <p class="calculator__form-result-txt-accent box-volume-total">${totalBoxVolume.toFixed(2)} м³</p>
          </div>
      </div>`;
  }
};

// Импорт и экспорт калькулятора нагрузки на оси
export { axleLoadCalculator } from './axleLoadCalculator';
